import { NavItemI } from '../../../../../shared/interfaces/nav-item.interface';

export const DROP_DOWN_ITEMS: NavItemI[] = [
  {
    translationPath: 'sideMenu.settings',
    activeIcon: 'svgs/side-menu/active-settings.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-settings.svg',
    route: ['settings/change-password'],
    alt: 'Settings',
  },
];
